import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import OrderTracking from "@/pages/OrderTracking";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerPanel from "@/pages/CustomerPanel";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AvisoLegal from "@/pages/legal/AvisoLegal";
import PoliticaPrivacidad from "@/pages/legal/PoliticaPrivacidad";
import PoliticaCookies from "@/pages/legal/PoliticaCookies";
import Condiciones from "@/pages/legal/Condiciones";
import ContactFab from "@/components/ContactFab";
import InstallPrompt from "@/components/InstallPrompt";
import { MobileBottomNav } from "@/components/nav/MobileBottomNav";
import { AuthCallback } from "@/components/AuthCallback";
import { CookieConsent } from "@/components/CookieConsent";
import { AdSenseLoader } from "@/components/AdSenseLoader";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/reservar" element={<Booking />} />
      <Route path="/pago/exito" element={<PaymentSuccess />} />
      <Route path="/pago/cancelado" element={<PaymentCancel />} />
      <Route path="/seguimiento" element={<OrderTracking />} />
      <Route path="/cuenta" element={<CustomerLogin />} />
      <Route path="/cuenta/panel" element={<CustomerPanel />} />
      <Route path="/cuenta/recuperar" element={<ForgotPassword />} />
      <Route path="/cuenta/restablecer" element={<ResetPassword />} />
      <Route path="/aviso-legal" element={<AvisoLegal />} />
      <Route path="/privacidad" element={<PoliticaPrivacidad />} />
      <Route path="/cookies" element={<PoliticaCookies />} />
      <Route path="/condiciones" element={<Condiciones />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/panel" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AppRouter />
        <MobileBottomNav />
        <ContactFab />
        <InstallPrompt />
        <CookieConsent />
        <AdSenseLoader />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
